export enum USER_TYPES {
  ADMIN = 'Administrator',
  USER = 'User',
  CUSTOMER = 'Customer'
}

export enum SHIPPING_TYPES {
  BNE = 'customer-collect-bne',
  SYD = 'customer-collect-syd',
  DELIVERY = 'delivery',
}

/** CURRENCY FORMATTER */
export const moneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

export const roundToTwo = (num: number) => Math.round(num * 100) / 100

export const validLimitDecimal = (amount: string): boolean => {
  const inputValue = amount
  // Use a regular expression to limit to a maximum of 2 decimal places and allow only valid numeric input
  const validValue = inputValue.match(/^\d+(\.\d{0,2})?$/) || ''
  if (!validValue[0]) {
    return false
  }
  return true
}

export const getFirstWord = (word: string): string => {
  const arrayWord = word.split(' ')
  return arrayWord.length > 0 ? arrayWord[0] : ''
}


export const dateFormat = (dateString: string): string => {
  const dateObject = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
  };

 return dateObject.toLocaleDateString('en-US', options);

}

export const formatDate = (date: Date) => {
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const yy = String(date.getFullYear()).slice(-2)
  return `${dd}.${mm}.${yy}`
}

export const formatDeliveryPreference = (value: string): string => {
  if (!value) return ''

  if (value === 'delivery') {
    return 'Delivery'
  }

  const parts = value.split('-')
  if (parts.length === 3 && parts[0] === 'customer' && parts[1] === 'collect') {
    const location = parts[2].toUpperCase()
    return `Customer Collect (${location})`
  }

  return value
}

export const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
export const allowedSpecialCharRegex = /[^a-zA-Z0-9,\.\-\(\)'" ]/
export const nonSpecialCharRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/
export const phoneRegex =
        /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/